import { ComputedValue } from './computed-value.model';

export class ArithmeticExpression implements ComputedValue {
  expressionText: string;
}
